/**
 * circuitProxy.js — thin wrappers around the `circuitRun` callable (server owns
 * all Circuit execution transitions). Clients never write circuit_run directly.
 */
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';

let _fn = null;
function fn() {
  if (!_fn) _fn = httpsCallable(functions, 'circuitRun', { timeout: 15000 });
  return _fn;
}
async function call(payload) { const r = await fn()(payload); return r.data; }

export const startCircuitRun = ({ circuitId, force, startedOnDevice = 'web' }) => call({ action: 'start', circuitId, force, startedOnDevice });
export const pauseCircuitRun = ({ epoch }) => call({ action: 'pause', epoch });
export const resumeCircuitRun = ({ epoch }) => call({ action: 'resume', epoch });
export const advanceCircuitRun = ({ epoch }) => call({ action: 'advance', epoch });
export const skipCircuitStep = ({ epoch }) => call({ action: 'skipStep', epoch });
export const addCircuitTime = ({ epoch, seconds }) => call({ action: 'addTime', epoch, seconds });
export const stopCircuitRun = ({ epoch }) => call({ action: 'stop', epoch });
export const reconcileCircuitRun = () => call({ action: 'reconcile' });
